import { render, staticRenderFns } from "./manage-addon-not-amount.vue?vue&type=template&id=643a05c0&scoped=true&"
import script from "./manage-addon-not-amount.vue?vue&type=script&lang=ts&"
export * from "./manage-addon-not-amount.vue?vue&type=script&lang=ts&"
import style0 from "./manage-addon-not-amount.vue?vue&type=style&index=0&id=643a05c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643a05c0",
  null
  
)

export default component.exports